import { useLifeCycleEventBus } from './useLifeCycleEventBus';

export const useLifeCycleEventBusLifeCycle = (eventName) => (useLifeCycleEventBus(eventName, true));
